import { boroughColour } from "../assets/colours";

export const sudsSitesLayer = {
  id: "suds-sites",
  type: "circle",
  paint: {
    "circle-radius": ["interpolate", ["linear"], ["zoom"], 10, 5, 20, 15],
  },
};

export const catchmentPartnershipLayer = {
  id: "catchment-partnership",
  type: "fill",
};

export const giglOpenSpaceLayer = {
  id: "gigl-open-space",
  type: "raster",
};

export const thamesCombinedLayer = {
  id: "thames-combined",
  type: "fill",
};

export const thamesSeparateLayer = {
  id: "thames-separate",
  type: "fill",
};

export const watercoursesLayer = {
  id: "watercourses",
  type: "fill",
};

export const boroughLayer = {
  id: "borough",
  type: "line",
  paint: {
    "line-color": boroughColour,
    "line-width": 2,
  },
};
